interface MainContentProps {
  children: React.ReactNode;
}

export function MainContent({ children }: MainContentProps) {
  return (
    <main 
      className="flex-1 overflow-y-auto"
      id="main-content"
      role="main"
      tabIndex={-1}
      aria-label="Main content"
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8">
        {children}
      </div>
    </main>
  );
}